module.exports = __webpack_public_path__ + "img/74.77514a48.png";